import styled from "styled-components";

export const StrategyActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .start-icon {
    path {
      stroke: #fff;
    }
  }

  .strategy-control-actions .dropdown-toggle .dropdown-toggle-split {
    border-radius: 25px !important;
    padding: 6px 13px 28px 12px;
    right: -4px !important;
    margin: 0px;
  }

  .lock-icon {
    cursor: pointer;
  }

  .dropdown-btn {
    padding: 5px 10px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    height: 36px;
  }

  .dropdown-toggle {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-top-right-radius: ${({ theme }) =>
      theme.constants.BORDER_RADIUS_8} !important;
    border-bottom-right-radius: ${({ theme }) =>
      theme.constants.BORDER_RADIUS_8} !important;
    position: inherit !important;
    &:focus {
      box-shadow: none;
    }
  }

  .dropdown-menu {
    margin-top: 0;
    background-color: ${({ theme }) => theme.global.color.senary} !important;

    &:after {
      border: none;
    }
    & > a {
      color: white;
      font-size: 12px;
      font-weight: 500;
      text-align: left;
    }
    & > a:hover {
      background-color: transparent !important;
      border-radius: 0% !important;
      color: white;
    }
  }

  .show-dropdown .dropdown-toggle-split {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-top-right-radius: ${({ theme }) =>
      theme.constants.BORDER_RADIUS_8} !important;
    border-bottom-right-radius: ${({ theme }) =>
      theme.constants.BORDER_RADIUS_8} !important;
  }

  .start-list-options-menu {
    position: absolute !important;
    top: -19px !important;
    right: -5px !important;

    &::after {
      display: inline-block;
    }
  }
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  align-items: center;

  .icon-button,
  .icon-small {
    padding: 10px;
    height: 35px;
    width: 35px;

    &:hover {
      background: ${({ theme }) => theme.dropdown.toggle.hover.color};
    }
  }

  .not-allowed {
    cursor: not-allowed;
  }

  .icon-small {
    padding: 8px;
  }

  .strategy-utility-dropdown .dropdown-menu {
    width: 150px;
  }
`;

export const TooltipContent = styled.div`
  gap: 14px;
  display: flex;
  flex-direction: column;
  padding: 15px;
  font-size: 15px;
  line-height: 23px;
  font-weight: 400;
  text-align: center;

  .content-line {
    width: 100%;
    display: block;
  }

  .upgrade-btn {
    width: 100%;
    border-radius: 25px;
  }
`;
